import { Component, OnInit } from '@angular/core';
import { AlertService } from '../../services/alert.service';
import { Alert, AlertType } from '../../models/Alerts';

@Component ({
  selector: 'alert-ui',
  template: '' +
  '<div class="alert-wrapper" *ngIf="visibleAlert">\n' +
  '    <alert *ngFor="let alert of alerts"  type={{alert.type}} [dismissible]="true" dismissOnTimeout="{{timeVisibleAlert}}">\n' +
  '      <strong>{{alert.title}}</strong> {{alert.msg}}\n' +
  '    </alert>\n' +
  '</div>',
  styleUrls: ['alert.component.sass']
})
export class AlertUIComponent implements OnInit {
  public titleAlert = AlertType;
  public alerts: Alert[] = [];
  public visibleAlert;
  public timeVisibleAlert: number = 3000;
  private timeCount;

  constructor(private alertServ: AlertService) {

    this.alertServ.getAlert().subscribe((data: Alert) => {
      clearTimeout(this.timeCount);
      if (!data) {
        this.alerts = [];
        return;
      }
      data.title = this.titleAlert[data.type];
      this.alerts.push(data);
      this.visibleAlert = true;
      this.timeCount = setTimeout(() => {
        this.visibleAlert = false;
        this.alerts = []
      }, this.timeVisibleAlert);
    });
  }
  ngOnInit () {

  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/components/alert/alert.component.ts